import { useEffect } from 'react';

import { appendProductToCookie } from '@containers/ProductDetailContainer/ProductDetail/LastVisitedProducts/utils';
import { getProductView_productDetailByMasterId_variants } from '@containers/ProductDetailContainer/queries/__generated__/getProductView';
import { IProduct } from '@containers/ProductListing/model';
import { EXCLUDE_FROM_LAST_VISITED } from '@utils/constants';

interface IUseAddToLastVisited {
  productId: IProduct['id'];
  variants: getProductView_productDetailByMasterId_variants[];
}

export const useAddToLastVisited = ({
  productId,
  variants,
}: IUseAddToLastVisited) => {
  useEffect(() => {
    const canBuy = variants.some((variant) => variant.canBuy === true);

    const canSaveToLastVisited = variants.every(
      (variant) => !variant.navigationValues.includes(EXCLUDE_FROM_LAST_VISITED)
    );
    if (canBuy && canSaveToLastVisited) {
      appendProductToCookie(productId);
    }
  }, [productId, variants]);
};
